import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=7177c3a8&"
import script from "./TabNavigation.vue?vue&type=script&lang=ts&"
export * from "./TabNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=7177c3a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
